import { render, staticRenderFns } from "./TestingRoute.vue?vue&type=template&id=e1bc0ad6&scoped=true"
import script from "./TestingRoute.vue?vue&type=script&lang=js"
export * from "./TestingRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bc0ad6",
  null
  
)

export default component.exports